// src/constants.js or src/constants.ts

// **Authentication Constants**
export enum AUTH {
    ADMINLOGIN='account Login',
    SUCCESS= 'Authentication Success',
    FAILED= 'Authentication failed',
    NOTLICENSED = 'Not Licensed User',
    TEMPUSER='temp user',
    BLOB='Has Blob Storage',
    TEMP_USER_CONFIG='temporary user configuration'
};
export enum EMAIL{
    LOGIN = 'Email Login',
    SUCCESS= 'Authentication Success',
    FAILED= 'Authentication failed',
    REJECT = 'Rejected',
    ERROR = 'Error'
}

export enum SLACKAUTH {
    SLACKLOGIN='slack Login',
    SUCCESS= 'login Success',
    TEAMSLOGIN= 'Teams Login',
    FAILED= 'login Failed',
    TEAMSSUCCESS = 'Teams Login Success'
};
export const filterOptions = [
    { label: "Not Authenticated", value: "NotAuthenticated" },
    { label: "Approval Pending", value: "ApprovalPending" },
    { label: "Authenticated", value: "Authenticated" },
    { label: "Rejected", value: "Rejected" },
    { label: "Revoked", value: "Revoked" },
    { label: "Licensed", value: "Licensed" },
    { label: "Migrated", value: "Migrated" },
    { label: "Expired", value: "Expired" },
  ];

  export enum ROLES {
    ADMIN='Admin',
    TEMP_USER= 'TempUser',
    USER= 'User',
    AZURE_RM='AzureRM'
};
export enum STATUS{
    NotAuthenticated = 0 ,
    ApprovalPending = 1,
    Authenticated = 2,
    Rejected = 3,
    Revoked = 4,
    Expired=7
}
export enum ACTIONS{
    ADD_LICENSE='Add License',
    REMOVE_LICENSE= 'Remove License',
    REVOKE= 'Revoke',
    AUTHENTICATE= 'Authenticate',
    CHECKTOKENVALIDITY='Check Token Validity',
    UPDATEREFRESHTOKEN='Update Refresh Token',
    RESEND='Resend',
}
export const STATUSORDER = [
    'ApprovalPending',
    'Authenticated',
    'Expired',
    'NotAuthenticated',
    'Rejected',
    'Revoked',
  ];
export enum AUTH_SERVICES {
    CheckTokenValidity = 'Admin/CheckMSTeamsTokenValidity',
    RefreshTokenStatus = 'Admin/RefreshTokenStatusUpdate',
}
export const DEFAULTSLACKAPP = {
  appName: "Saketa Migrator(Default)",
  partitionKey: "A09EFGX2885",
  clientID: "7018124503777.9491575076277",
  clientSecret:"",
  workspaceID: "",
  workspaceName: "",
};
export const SlackUrl="https://slack.com/oauth/v2/authorize"
  export const BATCH=50;